import { api, type UsersPreferences } from '@setplex/tria-api'
import { attach, createStore, StoreWritable } from 'effector'
import { produce } from 'immer'

// Get regions for authenticated users
export const getExtraFx = attach({
  effect: api.users.getExtraFx,
})

// Get regions for guests
export const getOnboardingExtraFx = attach({
  effect: api.onboarding.getOnboardingExtraFx,
})

// Used in onboarding popup
export const $regions: StoreWritable<UsersPreferences['regions'] | null> =
  createStore<UsersPreferences['regions'] | null>(null)
    .reset(
      getExtraFx,
      getOnboardingExtraFx,
      getExtraFx.fail,
      getOnboardingExtraFx.fail
    )
    .on([getExtraFx.doneData, getOnboardingExtraFx.doneData], (_, got) => {
      return got?.regions ?? []
    })

// Used in settings forms
export const $regionsAlphabeticallySorted = $regions.map((regions = []) =>
  produce(regions, (draft) => {
    draft?.sort((a, b) => a.name.localeCompare(b.name))
  })
)
